// extracted by mini-css-extract-plugin
export var Footer = "R_cQ";
export var aniBgLoading = "R_f";
export var aniSpin = "R_d";
export var column = "R_bh";
export var columns = "R_cT";
export var heading = "R_C";
export var link = "R_bj";
export var main = "R_c";
export var nav = "R_bg";
export var newsletter = "R_cV";
export var newsletter__heading = "R_cW";
export var scrollTop = "R_cR";
export var scrollTop__btn = "R_cS";